import Vue from "vue";
import Vuex from 'vuex';
Vue.use(Vuex);

// import * as actions from "./actions";
import * as getters from "./getters";

const state = {
	navCount:0,
	tyleCount: 1,
	comboCount: 1
}
const actions = {
    changeIndex({commit,state},navInd){
        commit("changeIndex",navInd);
    },
    getCurrentTyle({commit,state},tyleInd){
    	commit("getCurrentTyle",tyleInd)
    },
    getCurrentCombo({commit,state},comboInd){
    	commit("getCurrentCombo",comboInd)
    }
}
const mutations = {
	changeIndex(state,navInd){
		state.navCount = navInd;
		console.log(navInd)
	},
	getCurrentTyle(state,tyleInd){
		state.tyleCount = tyleInd;
	},
	getCurrentCombo(state,comboInd){
		state.comboCount = comboInd;
	}
	
}

export default new Vuex.Store({
	state,
	actions,
	mutations,
	getters

})


// WEBPACK FOOTER //
// ./src/vuex/store.js